<template>
  <div class="order-operation-notes is-relative">
    <b-loading :is-full-page="false" :active="fetching"></b-loading>
    <b-modal :active.sync="modalNote.active" has-modal-card>
      <order-operation-notes-modal
        :operation-id="operationId"
        @create-success="onCreateSuccess"
      />
    </b-modal>
    <b-table :data="logsNotes" >
        <template slot-scope="props">
            <b-table-column
                field="createdAt"
                label="Date"
            >{{ props.row.createdAt | formatDate("DD-MMM-YYYY HH:mm") }}</b-table-column>
            <b-table-column
                field="subtype"
                label="Type"
            >
              {{ props.row.subtype }}
              <b-button
                type="is-small"
                :loading="approving === props.row.id"
                @click="approve(props.row.id)"
                v-if="props.row.subtype === 'PENDING_APPROVAL' && canVetNotes"
              >
                APPROVE
              </b-button>
            </b-table-column>
            <b-table-column
                field="user.firstName"
                label="Creator"
            >{{ props.row.createdBy ? props.row.createdBy.fullName : "N/A" }}</b-table-column>
            <b-table-column
                field="content"
                label="Comment"
            >{{ props.row.content }}</b-table-column>
        </template>
        <template slot="empty">No logs and notes found.</template>
    </b-table>
  </div>
</template>

<script>
import moment from "moment";
import OrderOperationNotesModal from "./OrderOperationNotesModal";
import { OrderOperationService } from "@/services/orderOperation.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: {
    operationId: {
      type: Number | String,
      required: true
    },
    withComments: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrderOperationNotesModal
  },
  data: () => ({
    orderOperationService: OrderOperationService,
    modalNote: {
      active: false
    },
    logs: [],
    notes: [],
    fetching: false,
    approving: 0
  }),
  computed: {
    canVetNotes() {
      return this.$store.state.Auth.user.permissions.find(
        permission => permission.name === "can vet notes"
      );
    },
    logsNotes() {
      let logsNotes = this.logs;

      if (this.withComments) {
        logsNotes = logsNotes.concat(this.notes);
      }

      return logsNotes.sort((a, b) =>
        moment(a.createdAt).isBefore(moment(b.createdAt)) ? 1 : -1
      );
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.fetching = true;

      try {
        let promises = [this.fetchLogs()];

        if (this.withComments) {
          promises.push(this.fetchNotes());
        }

        const data = await Promise.all(promises);
        
        this.logs = data[0];
        
        if (this.withComments) {
          this.notes = data[1];
        }
      } catch (err) {}

      this.fetching = false;
    },
    fetchLogs() {
      return this.orderOperationService
        .listLogs(this.operationId, {includes: 'createdBy'})
        .then(response => JsonDenormalizer.denormalize(response));
    },
    fetchNotes() {
      return this.orderOperationService
        .listComments(this.operationId, {includes: 'createdBy'})
        .then(response => JsonDenormalizer.denormalize(response));
    },
    onCreate() {
      this.modalNote.active = true;
    },
    onCreateSuccess(note) {
      this.notes.push(note);
    },
    async approve(id) {
      this.approving = id;

      try {
        await this.orderOperationService.approveComment(this.operationId, id);
        await this.fetchNotes();

        this.$buefy.toast.open({
          message: "Note has been approved.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.approving = 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Order/OrderOperationNotes.vue